import Vue from 'vue';

Vue.mixin({
  computed: {
    $isMobile () {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    $isMobileSmall () {
      return this.$vuetify.breakpoint.smAndDown;
    },
    $isMobileXSmall () {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }
});
